import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { Icon, type IconName } from '../../../../../Icon';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderButtonIcon = (props: Props) => {
  const {
    name,
    color = theme.colors.DARK_KALE,
    width = SCREEN_HEADER_BUTTON_ICON_SIZE,
    height = SCREEN_HEADER_BUTTON_ICON_SIZE,
  } = props;

  return (
    <View style={styles.container}>
      <Icon color={color} height={height} name={name} width={width} />
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SCREEN_HEADER_BUTTON_ICON_SIZE = 20;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexShrink: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  color?: string;
  height?: number;
  name: IconName;
  width?: number;
};
